<ng-container *ngIf="list && list.length > 0">
    <ng-container *ngFor="let item of list">
        <ng-container *ngIf="item?.roles && item?.roles.length > 0; else blankTextBox">
            <div class="d-flex justify-content-start mt-3" *ngIf="!isCompanyISV">
                <h5 class="m-0">{{item?.codeChoice}}</h5>
            </div>
            <div class="beneficiary-detail-box">
                <ng-container *ngFor="let key of keys">
                    <ng-container *ngIf="item?.roles">
                        <ng-container *ngFor="let role of item?.roles">
                            <ng-container *ngIf="role[key?.key]; else outerKey">
                                <div class="beneficiary-detail-item">
                                    <p class="beneficiary-detail-label">{{key?.label}}</p>
                                    <h6>{{role[key?.key] ? role[key?.key] : 'N/A'}}</h6>
                                </div>
                            </ng-container>
                            <ng-template #outerKey>
                                <div class="beneficiary-detail-item">
                                    <ng-container *ngIf="isCompanyISV && key?.key === 'type'; else defaultTemplate">
                                        <p class="beneficiary-detail-label">{{ item[key?.key] }}</p>
                                        <h6>{{ item[key?.label] }}</h6>
                                    </ng-container>
                                    <ng-template #defaultTemplate>
                                        <p class="beneficiary-detail-label">{{key?.label}}</p>
                                        <h6>{{item[key?.key] ? item[key?.key] : 'N/A'}}</h6>
                                    </ng-template>
                                </div>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngFor="let placeholder of getPlaceholders(keys?.length)">
                    <div class="beneficiary-detail-item"></div>
                </ng-container>
            </div>
        </ng-container>
        <ng-template #blankTextBox>
            <div class="beneficiary-detail-item mt-3">
                <p class="beneficiary-detail-label">{{item?.type}}</p>
                <h6>{{ getBeneficiaryDescription(item) }}</h6>
            </div>
        </ng-template>
    </ng-container>
</ng-container>